import React, { useState } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import { Col, Row } from './Style';

const Preview = () => {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <Accordion style={{ width: '100%' }}>
      <Accordion.Title
        active={!collapsed}
        onClick={() => setCollapsed(!collapsed)}
      >
        <Icon name="dropdown" />
        미리보기
      </Accordion.Title>
      <Accordion.Content active={!collapsed}>
        <Col>
          <strong>
            사용자가 앱 내 공유하기를 눌러서 링크를 보낼 때 보이는 정보들
            세팅하는 곳입니다.
          </strong>
          <Row>
            <img src="/race/공유정보1.png" width={220} alt="공유정보1" />
            <img src="/race/공유정보2.png" width={220} alt="공유정보2" />
          </Row>
        </Col>
      </Accordion.Content>
    </Accordion>
  );
};

export default Preview;
